import {
  CostBasisCoveredLot,
  CostBasisMethodHolding,
} from '@interfaces/cost-basis/cost-basis.service.interface';
import {
  CostBasisPosition as _CostBasisPosition,
  FilteredCostBasisCoveredLot,
} from '@interfaces/cost-basis/cost-basis.service.interface';
import { Action, createReducer, on } from '@ngrx/store';
import { parseStr } from 'src/app/shared/helpers/cost-basis';
import { formatBalance } from 'src/app/shared/helpers/selected-accounts';

import {
  CostBasisMethodReset,
  LoadCostBasisLotsFail,
  LoadCostBasisLotsSuccess,
  LoadCostBasisMethodSuccess,
  UpdateSelectedPositions,
} from '../../actions';
import { UpdateSelectedPositionProperties } from '../../actions/cost-basis/cost-basis.actions';

export interface CostBasisPosition extends _CostBasisPosition {}
export interface CostBasisState {
  costBasisHoldingsMethod: CostBasisMethodHolding[];
  selectedPositions: CostBasisPosition[];
  costBasisCoveredLots: FilteredCostBasisCoveredLot[];
}

export const initialState: CostBasisState = {
  costBasisHoldingsMethod: [],
  selectedPositions: [],
  costBasisCoveredLots: [],
};

const configReducer = createReducer(
  initialState,
  on(LoadCostBasisMethodSuccess, (state, { payload }) => ({
    ...state,
    costBasisHoldingsMethod: payload,
  })),
  on(CostBasisMethodReset, (state) => ({
    ...state,
    costBasisHoldingsMethod: [],
  })),
  on(LoadCostBasisLotsSuccess, (state, { payload }) => ({
    ...state,
    costBasisCoveredLots: payload,
  })),
  on(LoadCostBasisLotsFail, (state) => ({
    ...state,
    costBasisCoveredLots: [],
  })),
  on(UpdateSelectedPositionProperties, (state, { payload }) => {
    const updatedPositions = state.selectedPositions.map((position, positionIndex) => {
      return positionIndex === payload.index ? { ...position, ...payload.props } : position;
    });
    return {
      ...state,
      selectedPositions: updatedPositions,
    };
  }),
  on(UpdateSelectedPositions, (state, { payload }) => ({
    ...state,
    selectedPositions: payload,
  })),
);

export function reducer(state: CostBasisState | undefined, action: Action) {
  return configReducer(state, action);
}

export const getSelectedPositions = (state: CostBasisState) => state.selectedPositions;
export const getCostBasisHoldingsMethod = (state: CostBasisState) => state.costBasisHoldingsMethod;
export const getCostBasisLots = (state: CostBasisState) => state.costBasisCoveredLots;

export const filterLotsData = (lots: CostBasisCoveredLot[]): FilteredCostBasisCoveredLot[] =>
  lots.map((lot) => ({
    lotID: lot.lotID,
    quantity: lot.quantity,
    /**
     * The market value comes in unformatted. We might get values with more than 2 decimals, which might impact some of the validations.
     * We are doing the value processing here, so that every consuming part of the app gets the rounded value.
     */
    marketValue: parseStr(formatBalance(lot.marketValue)),
    totalGainLoss: lot.totalGainLoss,
    aquiredDate: lot.aquiredDate,
    costperShare: lot.costperShare,
  }));
